import React, { useRef } from 'react';
import { withLocalize } from 'react-localize-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '../molecules/Tooltip';
import css from './ActionButton.css';
import Icon, { IconVariants } from '../foundations/Icon';

const ActionButton = ({
    newStyle = false,
    translate = () => {},
    text = '',
    primary = true,
    containerStyle = {},
    buttonIconStyle = {},
    buttonIconClass = '',
    disabledClass = '',
    disabled = false,
    containerClass = '',
    textReplace = {},
    icon = null,
    active = false,
    activeClass = '',
    flat = false,
    cssModifier,
    IconClass = null,
    tooltipText = '',
    changeTextOnClick = '',
    onClick = () => {},
}) => {
    const buttonTextRef = useRef(null);

    const handleClick = e => {
        e.preventDefault();

        if (changeTextOnClick !== '') {
            buttonTextRef.current.innerText = translate(changeTextOnClick) || text;
            setTimeout(() => {
                buttonTextRef.current.innerText = translate(text, textReplace) || text;
            }, 3000);
        }
        onClick(e);
    };

    let className;

    if (newStyle) {
        className = primary ? css.primary : css.secondary;
        if (flat) className = css.flat;
    } else {
        className = primary ? css.oldPrimary : css.oldSecondary;
    }

    return (
        <Tooltip titleTranslationKey={tooltipText} position="top" disabled={!tooltipText}>
            <button
                className={classNames(css.container, className, containerClass, {
                    [activeClass]: active,
                    [css.active]: active,
                    [css[cssModifier]]: cssModifier,
                })}
                onClick={handleClick}
                style={{
                    ...containerStyle,
                }}
                disabled={disabled}
            >
                <div
                    className={classNames(css.buttonInner, {
                        [css.disabledText]: disabled,
                        [disabledClass]: disabled,
                    })}
                    ref={buttonTextRef}
                >
                    {IconClass && (
                        <IconClass className={classNames(css.Icon, buttonIconClass, { [disabledClass]: disabled })} />
                    )}
                    {translate(text, textReplace)}
                    {icon && (
                        <Icon
                            name={icon}
                            style={buttonIconStyle}
                            variant={IconVariants.WHITE}
                            className={classNames(css.icon, buttonIconClass, { [disabledClass]: disabled })}
                        />
                    )}
                </div>
            </button>
        </Tooltip>
    );
};

ActionButton.propTypes = {
    newStyle: PropTypes.bool,
    text: PropTypes.string,
    textReplace: PropTypes.objectOf(PropTypes.any),
    onClick: PropTypes.func,
    primary: PropTypes.bool,
    flat: PropTypes.bool,
    disabled: PropTypes.bool,
    containerStyle: PropTypes.objectOf(PropTypes.any),
    containerClass: PropTypes.string,
    cssModifier: PropTypes.string,
    buttonIconStyle: PropTypes.objectOf(PropTypes.any),
    buttonIconClass: PropTypes.string,
    disabledClass: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    IconClass: PropTypes.func,
    activeClass: PropTypes.string,
    active: PropTypes.bool,
    changeTextOnClick: PropTypes.string,
    translate: PropTypes.func,
    tooltipText: PropTypes.string,
};

export default withLocalize(ActionButton);
